import React, { Component } from "react";
import { makeStyles, withStyles, useTheme, styled } from '@material-ui/core/styles';
import Save from '../../../assets/img/svg/save.svg';
import Cancel from '../../../assets/img/svg/cancel.svg';
import { getSettingsDateFormat, postSettingsDateFormat, getSettingsTimeszones, postSettingsTimeszones, getprojectbasicinfo } from "../../../actions/AddNewProjectAction"
import {
    TextField, FormControlLabel, Radio, Checkbox,
    Select, MenuItem, InputBase, Chip, Input, Button, InputAdornment,
    IconButton, FormHelperText, FormControl, RadioGroup
} from '@material-ui/core';
import withRouter from "../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import styles from "../../../assets/jss/customStyle";
import $ from "jquery"
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import axios from "axios";
import API from "../../../_helpers/endpointService"
import del from "../../../assets/img/svg/Del.svg"

const BootstrapError = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #f44336',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

const BootstrapInput = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

const names = [
    'Oliver Hansen',
    'Van Henry',
    'April Tucker',
    'Ralph Hubbard',
];

function getStyles(name, personName, theme) {
    return {
        fontWeight:
            personName.indexOf(name) === -1
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
    };
}

// const Settings = () => {
//     const classes = useStyles();
//     const theme = useTheme();
//     const [isError, setError] = React.useState(false);
//     const navigate = useNavigate();

//     const AddSave = () => {

//     }
//     const AddCancel = () => {
//         navigate("/operationplanningachievements")
//     };

class Settings extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isMobile: false,
            menu: true,
            ProjectName: "New Project",
            isEdit: false,
            // DateFormat: {
            //     ProjectId: 0,
            //     timeFormatId: 0,
            // },
            // TimeFormat: {
            //     ProjectId: 0,
            //     timeZoneId: 0,
            // },
            SettingsFormat: {
                "ProjectId": 0,
                "TimeZoneId": 0,
                "TimeFormatId": 0,
                "TimeZoneName": "",
                "Convention": "DD/MM/YYYY"
            }
        }
    };

    componentDidMount() {
        const { dispatch } = this.props;
        // this.state.SettingsFormat.TimeZoneName = "(UTC+05:30) India Standard Time (Kolkata)";
        this.state.ProjectName = localStorage.getItem("ProjectName");
        // this.state.SettingsFormat.TimeZoneId = 417;
        // this.state.SettingsFormat.TimeZoneName = "(UTC+05:30) India Standard Time (Kolkata)"
        // this.setState({})
        this.setState({})
        this.props.dispatch(getSettingsDateFormat())
        this.props.dispatch(getSettingsTimeszones())

        if (window.location.pathname == '/settings/add') {
            if (localStorage.getItem("addeditid") != null) {
                this.state.SettingsFormat.ProjectId = parseInt(localStorage.getItem("addeditid"));
                this.state.SettingsFormat.ProjectId = parseInt(localStorage.getItem("addeditid"));
                this.setState({})
                this.getprojectsettingsinfo(localStorage.getItem("addeditid"))
            }
        }
        if (window.location.pathname == '/settings/edit') {
            this.state.SettingsFormat.ProjectId = parseInt(localStorage.getItem("DashId"));
            this.state.SettingsFormat.ProjectId = parseInt(localStorage.getItem("DashId"));
            this.setState({})
            this.getprojectsettingsinfo(localStorage.getItem("DashId"))
        }
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    }
    getSettingsTimeszones = () => {

        let apiUrl = API.SETTINGS_PROJECT + "TimeZone";
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.props.dispatch({ type: "TIME_VALUES", data: response.data });

                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                }
            });
    };
    getSettingsDateFormat = () => {
        let apiUrl = API.SETTINGS_PROJECT + 'TimeFormat';
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.props.dispatch({ type: "FORMAT_VALUES", data: response.data });

                } else {

                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                }
            });
    };
    getprojectsettingsinfo = (data) => {
        
        let apiUrl = API.SETTINGS_PROJECT + data;
        // this.props.dispatch({type:"SHOW_LOADER",data:true})
        axios({
            method: "GET",
            url: apiUrl,

        })
            .then((response) => {
                if (response?.status === 200 ) {
                    this.state.SettingsFormat.TimeFormatId = response.data.TimeFormatId;
                    this.state.SettingsFormat.TimeZoneId = response.data.TimeZoneId;
                    this.state.SettingsFormat.TimeZoneName = response.data.TimeZoneName;
                    this.state.SettingsFormat.Convention = response.data.Convention;
                    // response.data.map((id) => (
                    //     id.TimeZoneName === this.state.SettingsFormat.TimeZoneName ? this.state.SettingsFormat.TimeZoneId = id.TimeZoneId : ""
                    // ))
                    this.setState({})
                   
                    // this.props.dispatch({type:"SHOW_LOADER",data:false})
                } else {
                    // this.props.dispatch({type:"SHOW_LOADER",data:false})
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    }

    componentWillUnmount() {
        clearInterval(this.interval);
        $("#Set1 .MuiListItemText-primary").removeClass("spanTopBar")
        $("#Settings1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#Settings").addClass("d-none");
        $("#Settings").removeClass("d-block");
        $("#S .MuiListItemText-primary").removeClass("fw-bolder");
        $("#SL").removeClass("active-color")
    }

    // sidebar = () => {
    //     if (window.location.pathname == '/settings/edit') {
    //         this.props.navigate("/sidebareditproject");
    //     }
    //     else {
    //         this.props.navigate("/sidebaraddproject");
    //     }
    // }
    sidebar = () => {
        if (this.state.cancel === true) {
            window.$("#cancelpopup1").modal("show");
        }
        else {
            if (window.location.pathname == '/settings/edit') {
                this.props.navigate("/sidebareditproject");
            }
            else {
                this.props.navigate("/sidebaraddproject");
            }
        }

    };
    SideBarCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup1").modal("hide");
        if (window.location.pathname == '/settings/edit') {
            this.props.navigate("/sidebareditproject");
        }
        else {
            this.props.navigate("/sidebaraddproject");
        }
    }
    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        $("#Set1 .MuiListItemText-primary").addClass("spanTopBar")
        $("#Settings1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Settings").removeClass("d-none");
        $("#Settings").addClass("d-block");
        $("#S .MuiListItemText-primary").addClass("fw-bolder");
        $("#SL").addClass("active-color")
    };

    handleInputChange = (e, node) => {
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        this.setState({})
        if (node == "TimeZoneId") {
            if (e.target.value == 0) {
                this.state.SettingsFormat.TimeZoneId = 417;
                this.state.SettingsFormat.TimeZoneName = "(UTC+05:30) India Standard Time (Kolkata)"
                this.setState({})
            }
            else {
                this.state.SettingsFormat.TimeZoneId = parseInt(e.target.value);
                this.state.SettingsFormat.TimeZoneName = e.target.options[e.target.selectedIndex].text
                this.setState({})
            }
        }
        if (node == "TimeFormatId") {
            this.state.SettingsFormat.TimeFormatId = parseInt(e.target.value);
            this.state.SettingsFormat.Convention = e.target.options[e.target.selectedIndex].text;
            this.setState({})
        }
    };

    AddCancel1 = () => {
        if (this.state.cancel == true) {
            window.$("#cancelpopup").modal("show");
        }
        else {
            this.props.dispatch({ type: "CANCEL", data: false });
            this.props.navigate(`/projectlist`)
        }
    }

    Save = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        this.props.dispatch(postSettingsDateFormat(this.state.SettingsFormat))
    };

    AddCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup").modal("hide");
        this.props.navigate(`/projectlist`)
    };

    // DeleteItem = () => {
    // }

    render() {
        const { isEdit } = this.state;
        let { classes, Format, Time, menuToggle } = this.props;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 mt-4">
                                <div className="col-7 mt-auto">
                                    <List className="pt-4 mt-4 " style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"Set" + "1"} className='textNaviIcon' primary={window.location.pathname == '/settings/edit' ? "Edit Project" : "New Project"} />
                                            <NavigateNextIcon id="Set" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-5 pt-2 mt-5">
                                    <h4 className="pt-1">Settings</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="ml-auto scroll-hide" style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    {
                        this.state.isMobile ?
                            <table className="dataTable border-top" width="100%">
                                <tbody>
                                    <tr>
                                        <td className="border-right text-center"><i class="fa fa-arrow-left cursorPointer" onClick={this.AddCancel1}></i></td>
                                        <td className="border-right text-center" >
                                            <button className={`${classes.button}`} onClick={() => { this.Save() }}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>
                                        </td>
                                        <td className="text-center">
                                            <button className={`${classes.button} `} onClick={this.AddCancel1}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            :
                            <>
                                <table className="dataTable" width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="5%" className="border-right text-center"><i class="fa fa-arrow-left cursorPointer" onClick={this.AddCancel1}></i></td>
                                            <td width="95%">
                                                <button className={classes.button} onClick={() => this.Save()}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>
                                                <button className={`${classes.button} pl-3`} onClick={this.AddCancel1}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table></>}
                    <div style={{ margin: this.state.isMobile ? "" : "5px" }}>
                        {this.state.isMobile ? "" : <h6 className="col-12 mx-2 mt-3 ml-1">{this.state.ProjectName}</h6>}
                        <div className={this.state.isMobile ? "row mx-0 mt-1" : "row mx-1 px-3 mt-2"}>
                            <div className={`row mt-2 mx-1 align-items-center ${this.state.isMobile ? "" : "text-row"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 mt-2 ${this.state.isMobile ? "border-left border-right border-top col-md-12" : "col-md-2 text-right"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2" : "text-right"}>Date Format&nbsp;:
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    <select className="form-control border-radius form-select" style={{ height: "40px", width: '100%', fontFamily: 'Segoe UI' }}
                                        onChange={(e) => { this.handleInputChange(e, "TimeFormatId") }}
                                        value={this.state.SettingsFormat.TimeFormatId}
                                    >
                                        {Format &&
                                            Format.map((i) => {
                                                return <option value={i.Id}>{i.Convertion}</option>;
                                            })}
                                    </select>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2 text-right"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2" : "text-right"}>Time Zone Format&nbsp;:
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12 pb-4  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    <select className="form-control border-radius form-select" style={{ height: "40px", width: '100%', fontFamily: 'Segoe UI' }}
                                        onChange={(e) => { this.handleInputChange(e, "TimeZoneId") }}
                                        value={this.state.SettingsFormat.TimeZoneId}
                                    >
                                        <option value={0}>Select Time Format</option>
                                        {Time &&
                                            Time.map((i) => {
                                                return <option value={i.Id}>{i.TimeZoneName}</option>;
                                            })}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div style={{ margin: this.state.isMobile ? "auto" : "15px 45px" }}>
                        {this.state.isMobile ? <></> : <h6 className="col-12 ml-2">{this.state.ProjectName}</h6>}
                        <div className="row px-4">
                            <div className="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2  mt-3">
                                <label>Date <label style={{ whiteSpace: 'nowrap' }}>Format :</label></label>
                            </div>
                            <div className="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4  mt-3">
                                <select className="form-control border-radius form-select" style={{ height: "40px", width: '100%', fontFamily: 'Segoe UI' }}
                                    onChange={(e) => { this.handleInputChange(e, "TimeFormatId") }}
                                    value={this.state.SettingsFormat.TimeFormatId}
                                >
                                    <option value={0}>Select Date Format</option>
                                    {Format &&
                                        Format.map((i) => {
                                            return <option value={i.Id}>{i.Convertion}</option>;
                                        })}
                                </select>
                            </div>
                            <div className="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mt-3">
                                <label>Time Zone <label style={{ whiteSpace: 'nowrap' }}>Format :</label></label>
                            </div>
                            <div className="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 mt-3">
                                <select className="form-control border-radius form-select" style={{ height: "40px", width: '100%', fontFamily: 'Segoe UI' }}
                                    onChange={(e) => { this.handleInputChange(e, "TimeZoneId") }}
                                    value={this.state.SettingsFormat.TimeZoneId}
                                >
                                    <option value={0}>Select Time Format</option>
                                    {Time &&
                                        Time.map((i) => {
                                            return <option value={i.Id}>{i.TimeZoneName}</option>;
                                        })}
                                </select>
                            </div>
                        </div>
                    </div> */}
                    <div class="modal fade p-5 mt-5" id="cancelpopup" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.AddCancel}><span className="" >Yes</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="cancelpopup1" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.SideBarCancel}><span className="" >Yes</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup1").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        Format: state.AddNewProjectReducer.Format || [],
        Time: state.AddNewProjectReducer.Time || [],
        getbasicinfo: state.AddNewProjectReducer.getbasicinfo || [],
    };
}

Settings.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Settings))
);
